import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import TransformationParameter from 'components/core/fields/transformation_parameters/TransformationParameter';
import MessageBox from 'components/core/MessageBox';
import DatastreamDefaultsTable from 'components/core/fields/transformation_parameters/DatastreamDefaultsTable.js';
import OverrideTable from 'components/core/fields/transformation_parameters/OverrideTable';

export default class QCMaskParameter extends TransformationParameter {
    static defaultProps = {
        parameterNames: ['qc_mask'],
        isOverridable: true,
        isDatastreamDefaultVisibileInitially: true,
        isOverrideVisibleInitially: true,
        infoBoxText: ''
    };

    renderMessageBox = () => {
        const preListText = 'We detected bit-packed QC with indeterminate bit assessments for the following variables:';
        return (
            <MessageBox>
                <Flexbox flexDirection={'column'}>
                    {this.getMessageBoxVariableList(preListText)}
                    <p className={css`font-style:italic;`}>(To view bit assessments, click the  Explore Input Data button at the top of the form)
                    </p>
                </Flexbox>
            </MessageBox>
        );
    };

    renderDatastreamDefaultQuestionText = () => {
        return 'Would you like to change any indeterminate bit assessments to bad by input datastream?';
    };

    renderOverrideQuestionText = () => {
        return 'Would you like to change any indeterminate bit assessments to bad by variable?';
    };

    renderDatastreamDefaultTable = () => {
        return (
            <QCMaskDatastreamDefaultsTable
                process={this.props.process}
                processErrors={this.props.processErrors}
                parameterNames={this.props.parameterNames}
                displayInputDatastream={this.props.displayInputDatastream}
                hasWritePermissions={this.props.hasWritePermissions}
                className={css`width:100%;`}
            />
        );
    };

    renderOverrideTable = () => {
        return (
            <QCMaskOverrideTable
                process={this.props.process}
                processErrors={this.props.processErrors}
                parameterNames={this.props.parameterNames}
                hasWritePermissions={this.props.hasWritePermissions}
                displayInputDatastream
            />
        );
    }
}

class QCMaskDatastreamDefaultsTable extends DatastreamDefaultsTable {
    getAdditionalColumns() {
        return ([
            {
                property: 'data',
                header: {
                    label: 'Bad QC bits',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQC(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'Indeterminate QC bits',
                },
                cell: {
                    formatters: [
                        data => { return this.renderIndQC(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'List of QC bits that should be interpreted as bad',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQCList(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'Value',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQCValue(data); }
                    ]
                }
            }
        ]);
    }
}

class QCMaskOverrideTable extends OverrideTable {
    getAdditionalColumns() {
        return ([
            {
                property: 'data',
                header: {
                    label: 'Bad QC bits',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQC(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'Indeterminate QC bits',
                },
                cell: {
                    formatters: [
                        data => { return this.renderIndQC(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'List of QC bits that should be interpreted as bad',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQCList(data); }
                    ]
                }
            },
            {
                property: 'data',
                header: {
                    label: 'Value',
                },
                cell: {
                    formatters: [
                        data => { return this.renderBadQCValue(data); }
                    ]
                }
            }
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/transformation_parameters/QCMaskParameter.js